// extracted by mini-css-extract-plugin
module.exports = {"container":"_3TdDx","titles":"_1ujmR","controls":"_3avxz","controlsButton":"BF9nh"};